import React from 'react';

const ChooseUs = () => {
  return (
    <div className='mt-0'>
      <div className="flex justify-center items-center space-x-4 mt-4 mb-20">
        <h2 className="font-robota font-bold mt-5 text-2xl sm:text-2xl md:text-4xl">
          What makes us the right choice?
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
        {/* Pricing and Features */}
        <div className="text-center flex flex-col items-center mb-6 sm:mb-8">
          <img
            src="/images/pricing.png"
            alt="Transparent pricing"
            className="w-20 h-20 mb-2"
          />
          <span className="font-medium text-lg text-gray-500">
            Transparent pricing
          </span>
        </div>
        <div className="text-center flex flex-col items-center mb-6 sm:mb-8">
          <img
            src="/images/tenyears.png"
            alt="Flat 10-year warranty"
            className="w-20 h-20 mb-2"
          />
          <span className="font-medium text-lg text-gray-500">
            Flat 10-year warranty
          </span>
        </div>
        <div className="text-center flex flex-col items-center mb-6 sm:mb-8">
          <img
            src="/images/forty5.png"
            alt="Delivery in 45 Days"
            className="w-20 h-20 mb-2"
          />
          <span className="font-medium text-lg text-gray-500">
            Delivery in 45 Days
          </span>
        </div>
        <div className="text-center flex flex-col items-center mb-6 sm:mb-8">
          <img
            src="/images/personaldesign.png"
            alt="Personalised designs"
            className="w-20 h-20 mb-2"
          />
          <span className="font-medium text-lg text-gray-500">
            Personalised designs
          </span>
        </div>
        <div className="text-center flex flex-col items-center mb-6 sm:mb-8">
          <img
            src="/images/nohiddencharges.png"
            alt="No Hidden Costs"
            className="w-20 h-20 mb-2"
          />
          <span className="font-medium text-lg text-gray-500">
            No Hidden Costs
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;
